module.exports = __webpack_public_path__ + "img/ok.34a68710.svg";